exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*最外层容器*/\r\n\r\n.app-root {\r\n    position: relative;\r\n    width: 100%;\r\n    height: auto;\r\n    min-height: 100%;\r\n    /* overflow: auto; */\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/index/index.component.css
// module id = ../../../../../src/app/home/components/system/index/index.component.css
// module chunks = main